import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgImageSliderCompatModule } from '../../../compat/ng-image-slider/ng-image-slider.module';
import { DirectivesModule } from '../../../directives.module';
import { SpinnerModule } from '../../components/spinner/spinner.module';
import { CustomDirectivesModule } from '../custom-directives/custom-directives.module';
import { CustomPipesModule } from '../custom-pipes/custom-pipes.module';
import { ActionMenuViewComponent } from './components/action-menu-view/action-menu-view.component';
import { AvatarViewComponent } from './components/avatar-view/avatar-view.component';
import { BellNotificationViewComponent } from './components/bell-notification-view/bell-notification-view.component';
import { ViewNotificationDialogComponent } from './components/bell-notification-view/view-notification-dialog/view-notification-dialog.component';
import { BookOrderActionViewComponent } from './components/book-order-action-view/book-order-action-view.component';
import { CarDamagesViewComponent } from './components/car-damages-view/car-damages-view.component';
import { ComponentResolverComponent } from './components/component-resolver/component-resolver.component';
import { OrderActionsCommonViewComponent } from './components/order-actions-common-view/order-actions-common-view.component';
import { OrderCargoDetailsViewComponent } from './components/order-cargo-details-view/order-cargo-details-view.component';
import { OrderClientDetailsViewComponent } from './components/order-client-details-view/order-client-details-view.component';
import { OrderCommonRowViewComponent } from './components/order-common-row-view/order-common-row-view.component';
import { OrderDetailsCardViewComponent } from './components/order-details-card-view/order-details-card-view.component';
import { OrderDetailsRowViewComponent } from './components/order-details-row-view/order-details-row-view.component';
import { OrderExecutersCommonViewComponent } from './components/order-executers-common-view/order-executers-common-view.component';
import { OrderIdentificatorCommonViewComponent } from './components/order-identificator-common-view/order-identificator-common-view.component';
import { OrderMarkersCommonViewComponent } from './components/order-markers-common-view/order-markers-common-view.component';
import { OrderPaidDateViewComponent } from './components/order-paid-date-view/order-paid-date-view.component';
import { OrderPaymentDetailsViewComponent } from './components/order-payment-details-view/order-payment-details-view.component';
import { OrderPriceDetailsViewComponent } from './components/order-price-details-view/order-price-details-view.component';
import { OrderStatusModernViewComponent } from './components/order-status-modern-view/order-status-modern-view.component';
import { PhoneViewComponent } from './components/phone-view/phone-view.component';
import { PriceDetailsViewComponent } from './components/price-details-view/price-details-view.component';
import { QuoteNotesViewComponent } from './components/quote-notes-view/quote-notes-view.component';
import { TimelineViewComponent } from './components/timeline/timeline-view/timeline-view.component';
import { OrderServiceFeeViewComponent } from './order-service-fee-view/order-service-fee-view.component';

@NgModule({
  declarations: [

    // Common
    AvatarViewComponent,
    ActionMenuViewComponent,
    TimelineViewComponent,
    QuoteNotesViewComponent,

    // Resolver
    ComponentResolverComponent,

    // Order
    OrderServiceFeeViewComponent,

    OrderCommonRowViewComponent,
    OrderIdentificatorCommonViewComponent,
    OrderMarkersCommonViewComponent,
    OrderExecutersCommonViewComponent,
    OrderActionsCommonViewComponent,

    OrderDetailsRowViewComponent,
    OrderDetailsCardViewComponent,
    OrderClientDetailsViewComponent,
    OrderCargoDetailsViewComponent,
    OrderPriceDetailsViewComponent,
    OrderPaidDateViewComponent,

    PriceDetailsViewComponent,
    OrderStatusModernViewComponent,
    OrderPaymentDetailsViewComponent,
    PhoneViewComponent,
    BellNotificationViewComponent,

    ViewNotificationDialogComponent,
    CarDamagesViewComponent,

    // Actions
    BookOrderActionViewComponent,
  ],
  exports: [
    // Common
    AvatarViewComponent,
    ActionMenuViewComponent,
    TimelineViewComponent,
    QuoteNotesViewComponent,

    ComponentResolverComponent,

    // Order
    OrderServiceFeeViewComponent,

    OrderCommonRowViewComponent,
    OrderIdentificatorCommonViewComponent,
    OrderMarkersCommonViewComponent,
    OrderExecutersCommonViewComponent,
    OrderActionsCommonViewComponent,

    OrderDetailsRowViewComponent,
    OrderDetailsCardViewComponent,
    OrderClientDetailsViewComponent,
    OrderCargoDetailsViewComponent,
    OrderPriceDetailsViewComponent,
    OrderPaidDateViewComponent,

    PriceDetailsViewComponent,
    OrderStatusModernViewComponent,
    OrderPaymentDetailsViewComponent,

    PhoneViewComponent,
    BellNotificationViewComponent,

    ViewNotificationDialogComponent,
    CarDamagesViewComponent,

    // Actions
    BookOrderActionViewComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    MatTabsModule,
    MatTooltipModule,
    NgImageSliderCompatModule,
    SpinnerModule,
    DirectivesModule,
    CustomDirectivesModule,
    CustomPipesModule,
  ],
})
export class CustomViewsModule { }
